import { DateTime } from '@ksyos/date-time';
import { Koi } from '@ksyos/koi';
import { CpapClassOption, MraAbcdScore, SptClassOption } from '@common/enums';
import { treatmentNames, TreatmentStatus } from './types';

const CpapValidOptions = Object.values(CpapClassOption);
const MraValidOptions = Object.values(MraAbcdScore);
const SptValidOptions = Object.values(SptClassOption);
const validClassifications = [...CpapValidOptions, ...MraValidOptions, ...SptValidOptions];

const classificationValidationDraft = Koi.string()
    .valid(...validClassifications, null)
    .optional();

const classificationValidationFinal = Koi.when('treatmentName', {
    is: 'CPAP',
    otherwise: Koi.when('treatmentName', {
        is: 'MRA',
        otherwise: Koi.when('treatmentName', {
            is: 'SPT',
            otherwise: Koi.valid(null),
            then: Koi.string()
                .valid(...SptValidOptions)
                .required(),
        }),
        then: Koi.string()
            .valid(...MraValidOptions)
            .required(),
    }),
    then: Koi.string()
        .valid(...CpapValidOptions)
        .required(),
});

export const allTreatmentsItemDraftSchema = Koi.object({
    classification: classificationValidationDraft,
    endDate: Koi.koi().todayOrBefore().allow(null),
    startDate: Koi.koi().todayOrBefore().allow(null),
    status: Koi.koi().enum(TreatmentStatus).allow(null).optional(),
    treatmentName: Koi.string()
        .valid(...treatmentNames)
        .required(),
});

export const allTreatmentsItemFinalSchema = Koi.object({
    classification: classificationValidationFinal,
    endDate: Koi.when('status', {
        is: TreatmentStatus.stopped,
        otherwise: Koi.koi().valid(null),
        then: Koi.custom((value) => {
            if (!value) {
                value = DateTime.now().toDate();
            }

            return value;
        }),
    }),
    startDate: Koi.custom((value) => {
        if (!value) {
            value = DateTime.now().toDate();
        }

        return value;
    }),
    status: Koi.koi().enum(TreatmentStatus).required(),
    treatmentName: Koi.string()
        .valid(...treatmentNames)
        .required(),
});

export const allTreatmentValidationDraft = Koi.array().items(allTreatmentsItemDraftSchema);
export const allTreatmentValidationFinal = Koi.array().items(allTreatmentsItemFinalSchema);
